import React from 'react';
import { useSelector } from 'react-redux';
import { getIsAppInitLoading, makeSelectAppInited } from './app/appSelectors';
import OpenMobileAppBanner from './modules/OpenMobileApp/OpenMobileAppBanner';
import MobileSliderPages from './mobileAppCore/components/MobileSliderPages/MobileSliderPages';
import { MobileAppStyled } from './mobileAppCore/components/styled/MobileAppStyled';
import MobileRoutePage from './mobileAppCore/pages/MobileRoutePage';
import MobileProviders from './mobileAppCore/providers/MobileProviders';
import { GlobalStyles } from './modules/GlobalStyles/GlobalStyles';
import { useLangContext } from './providers/LangProvider/LangProviderContext';
import { Loader } from './components/Loader/Loader';
import Announcement from './components/Announcement/Announcement';
import LogoScreen from "./components/Logo/LogoScreen";
import InternetConnectionProvider from './modules/InternetConnection/InternetConnectionProvider';
import { NoConnection } from './presentationalComponents/NoConnection/NoConnection';
import PwaProvider from './modules/Pwa/PwaProvider';
import LocationProvider from './modules/Location/LocationProvider';


const selectAppInited = makeSelectAppInited();

const MobileApp = () => {
    const { lang } = useLangContext();
    const isAppInitLoading = useSelector(getIsAppInitLoading);
    const isInited = useSelector(selectAppInited);

    return <>
        <GlobalStyles/>
        <Loader show={!isInited && isAppInitLoading}>
            <LogoScreen />
        </Loader>
        <InternetConnectionProvider/>
        <Announcement/>
        <PwaProvider/>
        <LocationProvider/>
        {
            isInited && (
                lang
                    ? (
                        <MobileProviders>{/* <-- Providers here*/}
                            <MobileAppStyled>
                                <OpenMobileAppBanner/>
                                <MobileRoutePage/>
                                <MobileSliderPages/>
                            </MobileAppStyled>
                        </MobileProviders>
                    ) : (
                        <NoConnection/>
                    )
            )

        }
    </>;
};

export default MobileApp;
